import React from 'react'
import '../../css/topbar.css'
import NepaliDate from 'nepali-datetime'

const Topbar = () => {
    const currentDatetime = new NepaliDate();

    return (
        <>
            <div className='topbar-style-1'>
                <h5>{currentDatetime.formatNepali('YYYY-MM-DD, dddd, hh:mm')}</h5>
            </div>
        </>
    )
}

export default Topbar